import { render, staticRenderFns } from "./table-sticky-2.vue?vue&type=template&id=7c2ca8f2&scoped=true"
import script from "./table-sticky-2.vue?vue&type=script&lang=js"
export * from "./table-sticky-2.vue?vue&type=script&lang=js"
import style0 from "./table-sticky-2.vue?vue&type=style&index=0&id=7c2ca8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ca8f2",
  null
  
)

export default component.exports